import isObject from '#shared/util/isObject.js';

import product from '#frontend/singleDataLayer/shared/product.js';

/**
 * User.update.order
 * User action to update order object in SDL
 * @param {object} cart cart object
 * @param {object} removedProduct Array of removed products
 * @returns {object} sdl object to push
 */
export default (cart, removedProduct) => {
	const productsObject = {
		user: {
			remove: {
				products: []
			}
		},
		order: {
			products: [] // all products in the order must be pushed in this array excluding the removed products
		},
		event: 'user.remove.products'
	};
	// Push removed product into products array
	if (isObject(removedProduct)) {
		productsObject.user.remove.products.push(product(removedProduct, cart.order));
	}
	// Check if is array and is not empty, push products into array
	if (Array.isArray(cart.order.products) && cart.order.products.length) {
		cart.order.products.forEach((productData) => {
			// Check if is not removed product
			if (productData.id !== removedProduct.id) {
				productsObject.order.products.push(product(productData, cart.order));
			}
		});
	}
	return productsObject;
};
